import { OhsUser } from 'user/OhsUser';
import { ModuleUrl, ModuleRoute } from 'global-services/constants/OhsRoutes';

const createRoute = (path: string, permission: (user: OhsUser) => boolean) => ({
  path,
  url: `/${ModuleUrl.Wmm}/${path}`,
  permission,
});

const OhsWmmSysFieldsRouteList = {
  [ModuleRoute.Home]: createRoute(
    'sys-fields/home',
    (user) => user?.configs?.sysfield?.PERMISSIONS.view || false
  ),
  [ModuleRoute.Details]: createRoute(
    'sys-fields/:id/view',
    (user) => user?.configs?.sysfield?.PERMISSIONS.view || false
  ),
  [ModuleRoute.Add]: createRoute(
    'sys-fields/add',
    (user) => user?.configs?.sysfield?.PERMISSIONS.create || false
  ),
  [ModuleRoute.Edit]: createRoute(
    'sys-fields/:id/edit',
    (user) => user?.configs?.sysfield?.PERMISSIONS.edit || false
  ),
};

export default OhsWmmSysFieldsRouteList;
